import { render, staticRenderFns } from "./OperaCommunityArticleTagWindow.vue?vue&type=template&id=04ef7f12"
import script from "./OperaCommunityArticleTagWindow.vue?vue&type=script&lang=js"
export * from "./OperaCommunityArticleTagWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports